import * as React from 'react'

import { Form, Section } from '@factorialco/deprecated-design-system'
import type { Form as FactorialForm } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import { periodScheduleTypeOptions } from 'modules/work_schedules/lib/periodScheduleTypeOptions'

interface Props {
  formRef: FactorialForm
  periodFormRef: FactorialForm
}

const GeneralInfoSection = ({ formRef, periodFormRef }: Props) => {
  return (
    <Section.TwoThirds
      illustration="document-edit"
      title={i18n.t('settings.work_schedule.general_info_section.title')}
      description={i18n.t('settings.work_schedule.general_info_section.description')}
    >
      <Form withBackground>
        <Text
          mandatory
          label={i18n.t('settings.work_schedule.settings_tab.edit_form.label')}
          placeholder={i18n.t('settings.work_schedule.settings_tab.edit_form.placeholder')}
          field={formRef.get('name')}
        />
        <Select
          label={i18n.t('settings.work_schedule.general_info_section.schedule_type.label')}
          options={periodScheduleTypeOptions()}
          field={periodFormRef.get('schedule_type')}
          showOriginalLabelText
          readonly
        />
      </Form>
    </Section.TwoThirds>
  )
}

export default observer(GeneralInfoSection)
